import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, notification, Typography, Space } from "antd";
import { useNavigate } from "react-router-dom";
import "../Auth/Login.css";
import { useState, useEffect } from "react";
import LayoutComp from "../../Components/LayoutComp";
import { UserService } from "../../Services/UserService";

//import myLogo from "../Image/logo-lamps.png";
// import myImage1 from "../Image/Design sans titre.png";
import myImage from "../Image/cards.png";
import myImgDss from "../Image/logoSoc.png";
const { /* Title, */ Text } = Typography;
const userService = new UserService();

const formatPortable = (value = "") => {
  const digits = value.replace(/\D/g, "").slice(0, 9);
  const parts = [];

  if (digits.length > 0) parts.push(digits.slice(0, 2));
  if (digits.length > 2) parts.push(digits.slice(2, 5));
  if (digits.length > 5) parts.push(digits.slice(5, 7));
  if (digits.length > 7) parts.push(digits.slice(7, 9));

  return parts.join(" ");
};

const Login = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState(0); // Nombre de tentatives
  const [isLocked, setIsLocked] = useState(false); // Verrouillage de connexion
  const [timeLeft, setTimeLeft] = useState(60); // Temps restant en secondes
  const [api, notificationHolder] = notification.useNotification();


  useEffect(() => {
    const lockTime = localStorage.getItem("lockTime");
    if (lockTime) {
      const timeElapsed = Date.now() - lockTime;

      if (timeElapsed < 60000) {
        setIsLocked(true);
        setTimeLeft(Math.ceil((60000 - timeElapsed) / 1000));
      } else {
        // Déverrouillage automatique
        localStorage.removeItem("lockTime");
        localStorage.removeItem("ajout");
      }
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsLocked(false);
    }
  }, [timeLeft]);




  const onFinish = (values) => {
    if (isLocked) {
      api.error({
        message: `Veuillez attendre encore ${timeLeft} seconde(s) avant de réessayer.`,
      });
      return;
    }

    setLoading(true);

    const portableSansEspaces = (values.portable || "").replace(/\s+/g, "");

    const payload = {
      ...values,
      portable: portableSansEspaces,
    };

    userService
      .connectUser(payload)
      .then((data) => {
        if (data.numcont && data.numcont !== "Empty") {

          if (data.pwd_portail === "Expired") {
            // Gérer le mot de passe expiré
            setLoading(false);
            const key = `open${Date.now()}`; // Clé unique pour la notification

            api.warning({
              message: "Mot de passe expiré",
              description:
                "Votre mot de passe a expiré. Veuillez le renouveler.",
              btn: (
                <Button
                  type="primary"
                  onClick={() => {
                    notification.destroy(key); // Fermer la notification
                    // showModal(data); // Ouvrir le modal
                  }}
                >
                  OK
                </Button>
              ),
              key, // Associe la clé unique pour pouvoir fermer la notification
              duration: 0, // Garde la notification ouverte jusqu'à ce que l'utilisateur clique sur "OK"
            });
          } else {
            // Connexion réussie
            const { prenom, nom, pwd_portail, portable, codesoc, datenaiss, matipm, matricule, numcont, email } =
              data;

            localStorage.setItem(
              "user_connect",
              JSON.stringify({ prenom, nom, pwd_portail, portable, codesoc, datenaiss, matricule, numcont, email })
            );
            localStorage.setItem("auth", "true");
            setAuth(true);

            // Stocke les données supplémentaires dans le localStorage

            localStorage.setItem("prenom", prenom);
            localStorage.setItem("nom", nom);
            localStorage.setItem("matipm", matipm);
            localStorage.setItem("codesoc", codesoc)
            localStorage.setItem("pwd_portail", pwd_portail);
            localStorage.setItem("portable", portable);
            localStorage.setItem("datenaiss", datenaiss);
            localStorage.setItem("matricule", matricule);
            localStorage.setItem("numcont", numcont);
            ;
            navigate("/dashboard");
          }
        } else {
          const newAttempts = attempts + 1;
          setAttempts(newAttempts);
          localStorage.setItem("ajout", newAttempts);

          if (newAttempts >= 3) {
            setIsLocked(true);
            localStorage.setItem("lockTime", new Date().getTime());
            setTimeLeft(60); // Réinitialiser le chronomètre à 60 secondes
            api.error({
              message: "Trop de tentatives échouées. Réessayez dans 1 minute.",
            });

            const interval = setInterval(() => {
              setTimeLeft((prev) => prev - 1);
            }, 1000);

            setTimeout(() => {
              clearInterval(interval);
              setIsLocked(false);
              setAttempts(0);
              localStorage.removeItem("ajout");
              localStorage.removeItem("lockTime");
            }, 60000);
          } else {
            api.error({
              message: "Login ou Mot de passe incorrect !",
            });
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        // Gérer les erreurs de l'API ici
        console.error(error);
        api.error({
          message: "Erreur de connexion",
          description:
            "Une erreur est survenue lors de la tentative de connexion.",
        });
        setLoading(false);
      });
  };

  if (localStorage.getItem("auth") === "true") {
    return <LayoutComp />;
  }
  else {
    return (

      <div className="modern-login">
        {notificationHolder}

        <div className="login-container">

          {/* Partie gauche avec une image occupant tout l’espace */}
          <div className="login-left">
            <img src={myImage} alt="Image" className="login-image" style={{ width: "100%", height: "100%" }} />
          </div>
          {/* Partie droite avec formulaire */}
          <div className="login-right">
            <div className="login-right-header">
              <img src={myImgDss} alt="DSS Logo" className="login-logo" />
              <Typography.Title level={4} style={{ textAlign: "center", marginBottom: 0, color: "#114b88" }}>
                Bienvenue dans votre <span style={{ color: "#f1ce57" }}>espace</span> personnel
              </Typography.Title>
            </div>
            <div className="login-right-content">
              <Form
                name="login-form"
                className="login-form"
                layout="vertical"
                size="large"
                onFinish={onFinish}
              >
                <Form.Item
                  label="Numéro de Téléphone"
                  name="portable"
                  getValueFromEvent={(e) => formatPortable(e?.target?.value || "")}
                  rules={[
                    { required: true, message: "Veuillez entrer votre numéro de téléphone !" },
                    {
                      pattern: /^\d{2} \d{3} \d{2} \d{2}$/,
                      message: "Format attendu : 99 999 99 99",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="99 999 99 99"
                    autoComplete="off"
                    maxLength={12}
                  />
                </Form.Item>

                <Form.Item
                  label="Mot de passe"
                  name="pwd_portail"
                  rules={[{ required: true, message: "Veuillez entrer votre mot de passe !" }]}
                >
                  <Input.Password prefix={<LockOutlined />} placeholder="Entrez votre mot de passe" />
                </Form.Item>

                <Form.Item >
                  <Space style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      loading={loading}
                      type="primary"
                      disabled={isLocked}
                      htmlType="submit"
                      className="login-button"
                      style={{ width: "100%" }}
                      icon={<LockOutlined spin={loading ? 1 : 0} style={{ transition: "transform 0.7s", transform: loading ? "rotate(360deg)" : "none" }} />}
                    >
                      Connexion
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
              <div className="login-attempt-message">
                {isLocked ? (
                  <Text type="danger">Veuillez attendre {timeLeft} seconde(s) avant de réessayer.</Text>
                ) : null}
              </div>
            </div>
            <div className="login-right-footer">
              <Text type="secondary">&copy; A2SMI 2026</Text>
            </div>
          </div>

        </div>
      </div>
    );
  }
};

export default Login;
